import { computeScrollPosition } from '../scroll-container/scroll-container.utils.js';

/**
 * Only surface a scroll arrow once a scrollable popup overflows or scrolls more than this many CSS
 * pixels past an edge. A popup with less overflow shows neither arrow.
 */
const SCROLLABLE_POPUP_SCROLL_MARGIN = 8;
/**
 * Vertical scroll position used to drive scroll-arrow visibility in popups such as menu-v2 and
 * Select. Reads the effective scroll amount directly from the scroll element, which works for both
 * scroll models:
 *
 * - the element scrolling its own `scrollTop` (menu-v2, Select fallback mode), and
 * - Select's default Floating UI `inner` mode, where the middleware sets `scrollTop = hiddenAbove`
 *   and clamps `max-height` so `scrollHeight - clientHeight - scrollTop === hiddenBelow`.
 *
 * Returns 'none' when there is no element yet. Callers are responsible for recomputing after layout
 * settles so the margin and subpixel guards do not latch onto a transient value.
 */
function getScrollablePopupScrollPosition(scrollElement) {
    if (!scrollElement)
        return 'none';
    return computeScrollPosition(scrollElement.scrollTop, scrollElement.scrollHeight, scrollElement.clientHeight, SCROLLABLE_POPUP_SCROLL_MARGIN);
}

export { SCROLLABLE_POPUP_SCROLL_MARGIN, getScrollablePopupScrollPosition };
//# sourceMappingURL=scrollable-popup.utils.js.map
